/** Ближайший вертикально-скроллящийся предок — внешний скролл страницы/вкладки.
 *  Общий для виртуализации базовой таблицы и грида вложений: оба меряют окно
 *  по внешнему скроллу, чтобы несколько списков на странице делили один скроллбар. */
export function findScrollParent(node: HTMLElement | null): HTMLElement | null {
    let el = node?.parentElement ?? null;
    while (el) {
        const oy = getComputedStyle(el).overflowY;
        if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') return el;
        el = el.parentElement;
    }
    return (document.scrollingElement as HTMLElement | null) ?? document.documentElement;
}
